<template>
  <div id="applicationStatusChart"></div>
</template>

<script>
  import c3 from 'c3'
  import d3 from 'd3'

  export default {
    name: 'application-status-chart',
    props: {
      chartData: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    mounted () {
      const data = this.chartData

      // Chart config
      const config = {
        bindto: '#applicationStatusChart',
        data: {
          x: 'x',
          columns: [
            data.x,
            data.oneclick_search,
            data.oneclick,
            data.premium,
            data.shop,
            data.insurance,
            data.bizcare,
            data.vpp,
            data.inquery,
            data.paid
          ],
          type: 'bar',
          groups: [
            ['oneclick_search', 'oneclick', 'premium', 'shop', 'insurance', 'bizcare', 'vpp', 'inquery', 'paid']
          ],
          names: {
            oneclick_search: '검토',
            oneclick: '원클릭',
            premium: '프리미엄',
            shop: '제품구매',
            insurance: '보험대행',
            bizcare: '비즈케어',
            vpp: '전력중개사업',
            inquery: '제휴/문의',
            paid: '이용권'
          },
          order: null
        },
        color: {
          pattern: ['#278A96', '#365ac0', '#9b88e9', '#8ebafb', '#ffd43b', '#ff6b6b', '#40678f', '#00c4ad', '#ff7133']
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              culling: {
                max: 8
              },
              fit: true,
              centered: true,
              multiline: false,
              format: function (x) {
                // MM/DD로 출력
                const month = x.getMonth() + 1
                const day = x.getDate()
                return `${month}/${day}`
              }
            }
          },
          y: {
            tick: {
              format: d3.format('d')
            },
            padding: {
              top: 8,
              right: 8
            }
          }
        },
        tooltip: {
          format: {
            title: function (x) {
              // YYYY년 MM월 DD일로 출력
              const year = x.getFullYear()
              const month = x.getMonth() + 1
              const day = x.getDate()
              return `${year}년 ${month}월 ${day}일`
            }
          }
        },
        point: {
          show: false
        },
        legend: {
          item: {
            tile: {
              width: 10,
              height: 10
            }
          },
          padding: 16
        }
      }

      // 컴포넌트 데이터에 차트 객체 복사 시 오류가 발생한다.
      // 대신 차트 객체를 Window 객체에 복사하여 사용한다.
      window.applicationStatusChart = c3.generate(config)
    },
    beforeDestroy () {
      // 컴포넌트 초기화 시 Window 객체에 복사된 차트 객체를 제거한다.
      delete window.applicationStatusChart
    }
  }
</script>

<style lang="scss">
  #applicationStatusChart {
    height: 232px;

    .c3-axis-y path {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/ApplicationStatusChart.vue